import cx from 'classnames';
import { useGetPurposeText } from 'pages/approvals/hooks/useGetPurposeText';
import { CircleFill } from 'react-bootstrap-icons';

/**
 * @param {boolean} completed
 * @param {string} [purpose]
 * @param {string} [tooltip]
 * @param {'approver' | 'viewer'} role
 */
export function PurposeStatusBadge({ completed = false, purpose = 'approve', tooltip, role }) {
    const purposeText = useGetPurposeText(purpose, completed, role);

    return (
        <div
            className={cx('flex-center font-weight-bolder', {
                'text-success': completed,
                'text-warning': !completed,
            })}
            style={{ whiteSpace: 'nowrap', fontSize: 12 }}
            data-uk-tooltip={tooltip}
        >
            <CircleFill size={7} className="flex-shrink-0 mr-1" />
            {purposeText}
        </div>
    );
}
